'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveAttachments = undefined;

var _createAsyncAction = require('conversations-internal-clients/action-creators/createAsyncAction');

var _resolveAttachmentsClient = require('../clients/resolveAttachmentsClient');

var _resolvedAttachmentsActionTypes = require('../constants/resolvedAttachmentsActionTypes');

var _buildResolvedAttachmentsMapFromResponse = require('../operators/buildResolvedAttachmentsMapFromResponse');

var resolveAttachments = exports.resolveAttachments = (0, _createAsyncAction.createAsyncAction)({
  requestFn: _resolveAttachmentsClient.resolveAttachmentsClient,
  actionName: _resolvedAttachmentsActionTypes.RESOLVE_ATTACHMENTS,
  toRecordFn: _buildResolvedAttachmentsMapFromResponse.buildResolvedAttachmentsMapFromResponse
});


//////////////////
// WEBPACK FOOTER
// ./js/resolved-attachments/actions/resolveAttachments.js
// module id = 598
// module chunks = 2 3